import { RidesViewTypeEnum } from "./rides.view-type.enum";

// TODO refactor this with `entityPathMappings` make one source of true for routes
export const RIDES_URL = "/rides";
export const BOOKINGS_URL = "/bookings";
export const REPORTS_URL = "/reports";
export const GRID_MULTI_SELECT_URL_PATH = "/grid";
export const GRID_SINGLE_SELECT_URL_PATH = "/table";
export const KANBAN_URL_PATH = "/kanban";
export const CARD_BOARD_URL_PATH = "/card-board";
export const MAP_URL_PATH = "/rides-map";
export const BOOKING_CALENDAR_URL_PATH = "/calendar";
export const COURSES_CALENDAR_URL_PATH = "/calendar";
export const RIDES_CALENDAR_URL_PATH = "/calendar";
export const ADD_URL_PATH = "/add";
export const EDIT_URL_PATH = "/edit/";
export const REPORTS_TABLE_PATH = "/table";
export const REPORTS_DIAGRAM_PATH = "/diagram";
export const REPORTS_INITIAL_PATH = `reports`;

export enum RoutePaths {
  HOME = "/",
  LOGIN = "/login",
  OAUTH_CONSENT = "/oauth/consent",
  MCP_CONNECTOR_ACTION = "/mcp/action",
  PROFILE = "/profile",
  COURSES = "/courses",
  REPORTS = "/reports",
  REPORTS_INITIAL = `/${REPORTS_INITIAL_PATH}`,
  PASSENGERS = "/passengers",
  PRODUCE_BUTTONS = "/produce_buttons",
  FEEDBACKS = "/feedbacks",
  NOTIFICATIONS = "/notifications",
  STATION_ROUTES = "/station_routes",
  SUPPLIER_PRICE_RATES = "/supplier_price_rates",
  PAGE_NOT_FOUND = "/pageNotFound",
  HELP_TOPICS = "/helptopics",
}
export enum RideRoutes {
  SEARCH_GRID_MULTI_SELECT = `${RIDES_URL}${GRID_MULTI_SELECT_URL_PATH}`,
  SEARCH_GRID_SINGLE_SELECT = `${RIDES_URL}${GRID_SINGLE_SELECT_URL_PATH}`,
  SEARCH_KANBAN = `${RIDES_URL}${KANBAN_URL_PATH}`,
  SEARCH_CARD_BOARD = `${RIDES_URL}${CARD_BOARD_URL_PATH}`,
  SEARCH_MAP = `${MAP_URL_PATH}`,
  SEARCH_CALENDAR = `${RIDES_URL}${RIDES_CALENDAR_URL_PATH}`,
  ADD_GRID_MULTI_SELECT = `${RIDES_URL}${GRID_MULTI_SELECT_URL_PATH}${ADD_URL_PATH}`,
  ADD_GRID_SINGLE_SELECT = `${RIDES_URL}${GRID_SINGLE_SELECT_URL_PATH}${ADD_URL_PATH}`,
  ADD_CARD_BOARD = `${RIDES_URL}${CARD_BOARD_URL_PATH}${ADD_URL_PATH}`,
  ADD_MAP = `${MAP_URL_PATH}${ADD_URL_PATH}`,
  ADD_KANBAN = `${RIDES_URL}${KANBAN_URL_PATH}${ADD_URL_PATH}`,
  ADD_CALENDAR = `${RIDES_URL}${RIDES_CALENDAR_URL_PATH}${ADD_URL_PATH}`,
  EDIT_BASE_GRID_MULTI_SELECT = `${RIDES_URL}${GRID_MULTI_SELECT_URL_PATH}${EDIT_URL_PATH}`,
  EDIT_BASE_GRID_SINGLE_SELECT = `${RIDES_URL}${GRID_SINGLE_SELECT_URL_PATH}${EDIT_URL_PATH}`,
  EDIT_BASE_KANBAN = `${RIDES_URL}${KANBAN_URL_PATH}${EDIT_URL_PATH}`,
  EDIT_BASE_MAP = `${MAP_URL_PATH}${EDIT_URL_PATH}`,
  EDIT_BASE_CARD_BOARD = `${RIDES_URL}${CARD_BOARD_URL_PATH}${EDIT_URL_PATH}`,
  EDIT_BASE_CALENDAR = `${RIDES_URL}${RIDES_CALENDAR_URL_PATH}${EDIT_URL_PATH}`,
}

export enum CoursesRoutes {
  SEARCH_GRID = `${RoutePaths.COURSES}`,
  SEARCH_CALENDAR = `${RoutePaths.COURSES}${COURSES_CALENDAR_URL_PATH}`,
}

export const RIDE_PRODUCTIONS_URL = "/ride_productions";

export enum RideProductionRoutes {
  SEARCH_GRID = RIDE_PRODUCTIONS_URL,
}

export enum BookingsRoutes {
  SEARCH_GRID = BOOKINGS_URL,
  SEARCH_CALENDAR = `${BOOKINGS_URL}${BOOKING_CALENDAR_URL_PATH}`,
  ADD = `${BOOKINGS_URL}${ADD_URL_PATH}`,
  ADD_CALENDAR = `${BOOKINGS_URL}${BOOKING_CALENDAR_URL_PATH}${ADD_URL_PATH}`,
  EDIT_BASE = `${BOOKINGS_URL}${EDIT_URL_PATH}`,
  EDIT_BASE_CALENDAR = `${BOOKINGS_URL}${BOOKING_CALENDAR_URL_PATH}${EDIT_URL_PATH}`,
}

export type AppNavigateRoutes =
  | RoutePaths
  | RideRoutes
  | BookingsRoutes
  | CoursesRoutes
  | RideProductionRoutes;
export type TPageRoute = typeof RIDES_URL | typeof BOOKINGS_URL;
export type TPageRouteFullPath = RideRoutes | BookingsRoutes;
export type TPageRouteSegmentPath =
  | typeof KANBAN_URL_PATH
  | typeof CARD_BOARD_URL_PATH
  | typeof GRID_MULTI_SELECT_URL_PATH
  | typeof GRID_SINGLE_SELECT_URL_PATH
  | typeof BOOKING_CALENDAR_URL_PATH;

export const rideEditNavigationBaseByType = {
  [RidesViewTypeEnum.GridMultiSelect]: RideRoutes.EDIT_BASE_GRID_MULTI_SELECT,
  [RidesViewTypeEnum.GridSingleSelect]: RideRoutes.EDIT_BASE_GRID_SINGLE_SELECT,
  [RidesViewTypeEnum.Kanban]: RideRoutes.EDIT_BASE_KANBAN,
  [RidesViewTypeEnum.Map]: RideRoutes.EDIT_BASE_MAP,
  [RidesViewTypeEnum.CardBoard]: RideRoutes.EDIT_BASE_CARD_BOARD,
  [RidesViewTypeEnum.LiveMap]: RideRoutes.EDIT_BASE_MAP,
  [RidesViewTypeEnum.Calendar]: RideRoutes.EDIT_BASE_CALENDAR,
} as const;

export const routePathFallbackMap: Record<TPageRoute, TPageRouteFullPath> = {
  [RIDES_URL]: RideRoutes.SEARCH_GRID_MULTI_SELECT,
  [BOOKINGS_URL]: BookingsRoutes.SEARCH_CALENDAR,
};
